<script lang="ts">
	//UI
	import ContainerLoading from "@hitit/hub/src/v7/components/common/ContainerLoading.svelte";
	import {
		SearchInput,
		Pagenation,
		NoticeStyleLink,
		CircleWithAdd,
	} from "@hitit/new_ui/src";
	//Utils
	import queryString from "query-string";
	import { api, t } from "@hitit/hub/src/stores";
	import { navigate, link } from "svelte-routing";
	import { globalHistory } from "svelte-routing/src/history";
	import { processingDate } from "@hitit/hub/src/v7/utils";
	import type { NewsListDTOList } from "@hitit/api";
	//Types
	type locationOverload = { search: string; pathname: string };

	//Props
	//Constants
	const theFirstQuery = parseQuerystring(window.location.search);
	//Variables
	let loading = false;
	let notices: NewsListDTOList[] = [];
	let temporarySearchText = "";
	let searchText = theFirstQuery.search;
	let presentPage = theFirstQuery.page;
	let totalPage = theFirstQuery.page;
	let totalElements = 0;
	//Functions
	const formSubmitHandler = (text: string) =>
		navigate(`/hubsetting/notice?search=${text}&page=0`);
	const pagenationClickHandler = (page: number) =>
		navigate(`/hubsetting/notice?search=${searchText}&page=${page}`);
	function parseQuerystring(query: string) {
		const parsed = queryString.parse(query);
		const { search, page } = parsed;
		const valideSearch = typeof search === "string" ? search : "";

		return {
			search: valideSearch,
			page: Number(page) || 0,
		};
	}

	async function getNoticeList(search = "", page = 0) {
		try {
			loading = true;
			// Set Data From API
			const { data } = await $api.getNewsDocumentList(search, page);
			notices = data.newsListDTOList;
			totalElements = data.totalElements;
			totalPage = data.totalPages;
		} catch (error) {
			//
		} finally {
			loading = false;
		}
	}
	//Do
	globalHistory.listen((v) => {
		const query = parseQuerystring((v.location as locationOverload).search);
		searchText = query.search;
		presentPage = query.page;
	});
	$: getNoticeList(searchText, presentPage);
</script>

{#if loading}
	<ContainerLoading />
{/if}
<div class="container">
	<div class="header">
		<form
			on:submit|preventDefault={() => formSubmitHandler(temporarySearchText)}
		>
			<SearchInput
				bind:value={temporarySearchText}
				placeholder={$t("global.search_article")}
			/>
		</form>
		<a class="new-article" use:link href="/hubsetting/notice/edit">
			추가
			<span class="icon">
				<CircleWithAdd fill={"#6591fa"} />
			</span>
		</a>
	</div>
	<div class="body">
		<ul class="list">
			{#each notices as notice}
				<NoticeStyleLink
					status={notice.documentState}
					title={notice.title}
					date={processingDate(notice.createdDate, "yyyy.MM.DD")}
					linkHref={`/hubsetting/notice/read/${notice.id}`}
				/>
			{/each}
		</ul>
		{#if totalElements}
			<Pagenation
				presentPage={presentPage}
				totalPage={totalPage}
				buttonCallback={pagenationClickHandler}
			/>
		{/if}
	</div>
</div>

<style lang="scss">
	@import "../../variables.scss";
	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 20px;

		.header {
			display: flex;
			flex-direction: column;
			gap: 20px;

			.new-article {
				display: flex;
				align-items: center;
				margin-left: auto;
				text-decoration: none;
				font-weight: 500;
				color: #6d6f76;
				gap: 10px;
				.icon {
					width: 24px;
					height: 24px;
				}
			}
		}
		.body {
			display: flex;
			flex-direction: column;
			gap: 20px;

			.list {
				list-style: none;
				display: flex;
				flex-direction: column;
				gap: 10px;
			}
		}
	}

	@include DesktopSize {
		.container {
			.header {
				gap: 30px;

				form {
					max-width: 787px;
				}

				.new-article {
					font-size: 1.25rem;
				}
			}
			.body {
				gap: 30px;

				.list {
					gap: 20px;
				}
			}
		}
	}
</style>
